/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback, useMemo } from "react";
import { nanoid } from "nanoid";
import Calculate from "components/payments/Calculator";
import Formmoneypay from "components/payments/Inputmoneypay";

const STEPS = {
  CREATE_PAYMENT: 1,
  SHOW_QR: 2,
  PAYMENT_SUCCESS: 3,
};

export default function PayQrCode({
  payment,
  money,
  actions,
  order,
  ui,
  provider,
  ...props
}) {
  const { data, setData, selectedMethod } = payment;
  const { amount, setAmount } = money;
  const { completePayment } = actions;
  const { details } = order;
  const { buttons } = ui;

  const [step, setStep] = useState(STEPS.CREATE_PAYMENT);
  const [paymentQr, setPaymentQr] = useState(null);
  const [time, setTime] = useState(0);
  const [count, setCount] = useState(0);
  const [payID] = useState(nanoid());

  const handleGenerateQr = useCallback(
    (paymentAmount) => {
      if (!paymentAmount) return;

      const item = {
        id: payID,
        amount: paymentAmount,
        qrImage: "/img/image_qr.png",
        status: 0,
      };

      setPaymentQr(item);
      setStep(STEPS.SHOW_QR);
      handleAddPayment(paymentAmount);
    },
    [payID]
  );

  const handleAddPayment = useCallback(
    (paymentAmount) => {
      const paymentItem = {
        id: payID,
        channel: selectedMethod,
        amount: paymentAmount || amount,
        provider: null,
        status: 0,
      };

      setData((prev) => [...(Array.isArray(prev) ? prev : []), paymentItem]);

      setAmount("0");
    },
    [payID, selectedMethod, amount, setData, setAmount]
  );

  const checkPaymentStatus = useCallback(() => {
    if (!paymentQr) return;

    if (count === 0) {
      setCount(1);
      setTime(5);
    } else {
      const status = "success";

      if (status === "success" || status === "fail") {
        setData((prev) =>
          prev.map((el) =>
            el.id === paymentQr.id
              ? { ...el, status: status === "success" ? 1 : 2 }
              : el
          )
        );

        setPaymentQr(null);
        setStep(STEPS.PAYMENT_SUCCESS);
      } else {
        setCount(0);
      }
    }
  }, [paymentQr, count, setData]);

  useEffect(() => {
    let timer;

    if (time > 0) {
      timer = setTimeout(() => setTime(time - 1), 1000);
    } else if (paymentQr) {
      checkPaymentStatus();
    }

    return () => clearTimeout(timer);
  }, [time, paymentQr, checkPaymentStatus]);

  const paymentData = useMemo(() => {
    if (!data || !Array.isArray(data)) return null;

    return data.find((p) => p.id === payID);
  }, [data, payID]);

  const isAmountValid = parseFloat(amount) > 0;

  return (
    <>
      {step === STEPS.CREATE_PAYMENT && (
        <div>
          <div className="d-flex align-items-center text-[#061126] mb-1">
            <div className="me-auto">
              <span className="fs-18 fw-500">Order NO.</span>
              <span className="fs-14 fw-500 ms-2">
                {details?.orderNo || ""}
              </span>
            </div>
            <div className="fs-18 fw-bold text-[#2DC76D]">
              สร้าง QR ชำระเงิน
            </div>
          </div>

          <div className="fs-14 fw-500 mb-3">กรุณาระบุยอดเงินรับชำระ</div>

          <div className="py-2">
            <Formmoneypay moneypay={amount} setMoneypay={setAmount} />
          </div>

          <Calculate
            setMoneypay={setAmount}
            moneypay={amount}
            PaymentDetail={details}
          />

          <div className="d-flex align-items-center pt-2">
            <button
              className="me-auto btn btn-st-q1 px-5"
              onClick={() => handleGenerateQr(amount)}
              disabled={!isAmountValid}
            >
              Enter
            </button>
            <button
              className="btn btn-st-q1"
              onClick={completePayment}
              disabled={buttons.paymentDisabled}
            >
              ชำระเงิน
            </button>
          </div>
        </div>
      )}

      {step === STEPS.SHOW_QR && paymentQr && (
        <div className="pt-5 px-4">
          <div className="text-center fs-24 fw-500 text-[#061126] mb-2">
            080-888-8762
          </div>
          <div className="text-center fs-24 fw-500 text-[#061126]">
            โรงคั่วกาแฟพะเยา
          </div>

          <div className="text-center my-2">
            <img
              src={paymentQr.qrImage}
              className="w-100 mx-auto"
              style={{ maxWidth: "338px" }}
              alt="QR Code for payment"
            />
          </div>

          <div className="d-flex align-items-center">
            <div className="me-auto fs-24 fw-500 text-[#061126]">
              ยอดที่ต้องชำระ
            </div>
            <div className="text-nowrap d-flex align-items-center">
              <span className="fs-36 fw-bold text-[#2DC76D] me-4">
                {paymentQr.amount}
              </span>
              <span className="fs-18 fw-500 text-[#2DC76D] pt-2">THB</span>
            </div>
          </div>

          <div className="text-center my-3">
            <button
              className="btn btn-x1 btn-x1-print text-[#FFF]"
              style={{ paddingLeft: "40px" }}
            >
              พิมพ์ QR code
            </button>
          </div>
        </div>
      )}

      {step === STEPS.PAYMENT_SUCCESS && (
        <div className="pt-5 px-4 h-100 d-flex flex-column justify-content-center">
          <div className="text-center mb-4 pt-5 mt-5">
            <img
              className="w-[min(8.11vw,83px)] aspect-square object-contain rounded-full mx-auto"
              src="/img/icons/icon-success.png"
              alt="Success Icon"
            />
          </div>

          <div className="text-center fs-36 fw-500 mx-auto text-[#2DC76D] mt-4 mb-5">
            การชำระเงินเสร็จสิ้น
          </div>

          <div className="d-flex align-items-center mb-auto">
            <div className="me-auto fs-24 fw-500 text-[#061126]">
              จำนวนที่ชำระ
            </div>
            <div className="text-nowrap d-flex align-items-center">
              <span className="fs-36 fw-bold text-[#2DC76D] me-4">
                {paymentData?.amount || ""}
              </span>
              <span className="fs-18 fw-500 text-[#2DC76D] pt-2">THB</span>
            </div>
          </div>

          <div className="text-end">
            <button
              className="btn btn-st-q1"
              onClick={completePayment}
              disabled={buttons.paymentDisabled}
            >
              ชำระเงิน
            </button>
          </div>
        </div>
      )}
    </>
  );
}
